import { colorsClassesMap } from '@cian/ui-kit-design-tokens/colors';
import colorStyles from '@cian/ui-kit-design-tokens/colors/colors.module.css';
import deprecatedColorStyles from '@cian/ui-kit-design-tokens/colors/deprecated/colors.module.css';
import backgroundStyles from '@cian/ui-kit-design-tokens/colors/deprecated/backgrounds.module.css';
import borderColorStyles from '@cian/ui-kit-design-tokens/colors/deprecated/borderColors.module.css';
export function getColorProps(color) {
  var className = deprecatedColorStyles["color_".concat(color)];
  if (className) {
    return {
      className: className
    };
  }
  if (colorsClassesMap[color]) {
    return {
      style: {
        color: "var(--".concat(color, ")")
      }
    };
  }
  return {
    style: {
      color: color
    }
  };
}
export function getBackgroundProps(background) {
  var className = backgroundStyles["background_".concat(background)];
  if (className) {
    return {
      className: className
    };
  }
  if (colorsClassesMap[background]) {
    return {
      style: {
        background: "var(--".concat(background, ")")
      }
    };
  }
  return {
    style: {
      background: background
    }
  };
}
export function getBorderProps(_ref) {
  var borderColor = _ref.borderColor,
    borderStyle = _ref.borderStyle,
    borderWidth = _ref.borderWidth;
  var style = {};
  var borderColorClassName = colorStyles["color_".concat(borderColor)] || borderColorStyles["borderColor_".concat(borderColor)];
  if (!borderColorClassName) {
    style.borderColor = borderColor;
  }
  if (borderStyle) {
    style.borderStyle = borderStyle;
  }
  if (borderWidth) {
    style.borderWidth = "".concat(borderWidth, "px");
  }
  return {
    style: style,
    className: borderColorClassName
  };
}